import React from 'react';
import Responsive from 'react-responsive';
import { css } from 'styled-components';

const sizes = {
  largeDesktop: 1200,
  desktop: 992,
  tablet: 768,
  phone: 0,
};

/* eslint-disable */
export const OnDesktop = ({ children }) => (
  <Responsive minWidth={sizes.desktop}>{children}</Responsive>
);

export const OnDesktopAndTablet = ({ children }) => (
  <Responsive minWidth={sizes.tablet}>{children}</Responsive>
);

export const OnTablet = ({ children }) => (
  <Responsive minWidth={sizes.tablet} maxWidth={sizes.desktop}>
    {children}
  </Responsive>
);

// https://github.com/contra/react-responsive/issues/56
export const OnPhone = ({ children }) => (
  <Responsive maxWidth={sizes.tablet}>
    <div>{children}</div>
  </Responsive>
);
/* eslint-enable */

// iterate through the sizes and create a media template
const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)}
    }
  `;
  return accumulator;
}, {});

export default media;
